export default class AccountSubtype {
  id = 0;
  name = "";
  type = 0;

  bankStatItemPartnerId = 0;

  /** Utókalkulációs altípus (csaccaccsubtype.is_postcalc / postcalc_type) */
  isPostCalc = false;
  postCalcType = 1;

  constructor(params?: Partial<AccountSubtype>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}
